import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { useTranslation } from "src/_common/hooks/useTranslation";

interface ReportsPieChartProps {
  data: Array<{
    name: string;
    value: number;
    color: string;
  }>;
  className?: string;
}

const ReportsPieChart: React.FC<ReportsPieChartProps> = ({ data, className }) => {
  const { t } = useTranslation("settings");

  // Custom tooltip component
  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="pie-tooltip">
          <p className="tooltip-label">{payload[0].name}</p>
          <p className="tooltip-value">Count: {payload[0].value}</p>
        </div>
      );
    }
    return null;
  };

  // Custom legend component
  const CustomLegend = () => {
    return (
      <div className="pie-legend">
        {data.map((entry, index) => (
          <div key={index} className="legend-item">
            <span className="legend-dot" style={{ backgroundColor: entry.color }}></span>
            <span className="legend-text">{entry.name}</span>
          </div>
        ))}
      </div>
    );
  };

  // If no data, show message
  if (!data || data.length === 0) {
    return (
      <div className={`reports-pie-chart ${className || ""}`}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "300px",
            color: "#6b7280",
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          {t("reports.charts.pieChart.noData")}
        </div>
      </div>
    );
  }

  return (
    <div className={`reports-pie-chart ${className || ""}`}>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie data={data} cx="50%" cy="50%" innerRadius={60} outerRadius={120} paddingAngle={2} dataKey="value">
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      </ResponsiveContainer>
      <CustomLegend />
    </div>
  );
};

export default ReportsPieChart;
